import * as React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from "moment";


export class DatePicker extends React.Component<any> {
    handleChange = (date: any) => {
        if (this.props.disabled) {
            return;
        }
        let value = null;
        if (date) {
            value = this.props.showTimeSelect ? date.format("YYYY-MM-DD HH:mm") : date.format("YYYY-MM-DD");
            if (this.props.showTimeSelectOnly) {
                value = date.format("HH:mm");
            }
            this.props.onChange(value);
        } else {
            this.props.onChange(value);
        }
    };

    render() {
        const {
            name,
            value,
            placeholder,
            showTimeSelect = false,
            showTimeSelectOnly = false,
            disabled = false,
            dateFormat = "DD-MM-YYYY",
            intervals = 15,
            inline = false
        } = this.props;

        let selectedValue = value ? value : null;

        if (showTimeSelectOnly && value) {
            selectedValue = moment().format("YYYY-MM-DD") + " " + value;
        }

        const element = (
            <ReactDatePicker
                className="form-control"
                dateFormat={dateFormat}
                placeholderText={placeholder}
                name={name}
                disabled={disabled}
                selected={selectedValue ? moment(selectedValue) : null}
                onChange={this.handleChange}
                showTimeSelect={showTimeSelect}
                showTimeSelectOnly={showTimeSelectOnly}
                timeFormat="HH:mm"
                timeIntervals={intervals}
            />
        );

        return inline ? element : <div>{element}</div>;
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/fields/DatePicker.tsx